import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class SentryMissingTranslationHandler implements MissingTranslationHandler {
  private sentKeys = [];

  handle(params: MissingTranslationHandlerParams) {
    if (Object.keys(params.translateService.store.translations).length === 0) {
      return;
    }
    const key = params.key;
    if (!this.sentKeys.includes(key)) {
      //console.error('Missing translation for key: ' + key + ' and language: ' + params.translateService.currentLang);
      //Sentry.captureMessage('Missing translation for key: ' + key + ' and language: ' + params.translateService.currentLang);
      this.sentKeys.push(key);
    }
    return key;
  }
}
